<script setup lang="ts">
import { i18n } from '@/i18n';
import { IRecommendOrderErrorType } from '../pages/interfaces/recommendOrderError';
import { RecommendOrderViewModel } from '../pages/recommendOrderViewModel';

const t = i18n.t;

defineProps<{
  errorType: IRecommendOrderErrorType;
}>();

const vm = new RecommendOrderViewModel();
</script>

<template>
  <div class="invalid-order-alert__container">
    <i18n-t class="invalid-order-alert__content" :keypath="vm.getI18nKeyPathOfErrorMessage(errorType)" tag="div">
      <template #newLine>
        <br />
      </template>
    </i18n-t>
  </div>
</template>

<style lang="scss" scoped>
.invalid-order-alert {
  &__container {
    background-color: $semanticWhite;
    display: grid;
    place-items: center;
  }

  &__content {
    font-family: 'Noto Sans JP';
    font-weight: 700;
    font-size: 16px;
    line-height: 32px;
    text-align: center;
    color: $textDefault;
  }
}
</style>
